// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"

export function jobPageTemplateRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns general job page template details
     * @param tenantId targeted tenant
     * @param jobShopId id of the JobShop from which the page is part of
     * @param locale language locale for the Accept-Language header
     * @param templateId id of the requested template
     * @returns
     */
    async getJobPageTemplateById(tenantId: string, jobShopId: string, locale: string, templateId: string | null): Promise<Page> {
      return fetch<Page>(`${UrlConfig.PATH_BASE_CONTENT_SERVICE}/public/job-page-templates`, {
        headers: {
          "Accept-Language": locale,
          "Accept": "application/json",
          "X-Tenant-Id": tenantId,
          "X-JobShop-Id": jobShopId,
        },
        params: {
          template_id: templateId,
        },
      })
    },
  }
}
